/**
 * AdminGuard — redirects non-admin users to / silently.
 *
 * Wraps admin-only routes. Pairs with ProtectedRoute (auth gate) — use
 * both: `<ProtectedRoute><AdminGuard>{children}</AdminGuard></ProtectedRoute>`
 * so anonymous users land on /login and authenticated-but-not-admin
 * users land on /.
 */

import { Navigate } from 'react-router-dom';

import { useIsAdmin } from '@/hooks/useIsAdmin';

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const admin = useIsAdmin();
  if (!admin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
